
import React, {Component} from 'react';
import {Button} from 'react-bootstrap'
import EmployeeBarCodeButton from './EmployeeBarCodeButton'
import EmployeeQRCodeButton from './EmployeeQRCodeButton'
import FontAwesome from 'react-fontawesome'


class EmployeeCodeButton extends Component {

  constructor(...args){
    super(...args)
    
  }

  onClick(){
    
  }

  render(){
    let {type} = this.props

    if(type==='qrcode'){
      return (<EmployeeQRCodeButton {...this.props} />)
    }else if(type==='barcode'){
      return (<EmployeeBarCodeButton {...this.props}   />)
    }else{
      return (<div/>)
    }    
  }
}

export default EmployeeCodeButton;





// WEBPACK FOOTER //
// ./src/view/hr/EmployeeCodeButton.js